import {
  Button,
  DropdownTree,
  Form,
  Grid,
  GridColumn,
  GridRow,
  Gutter,
  Input,
  Layout,
} from '@axiom/ui';
import React from 'react';

import { eventPurposeOptions } from '../../stores/app-event-item-modal-store';

import { activityLogFilterSchema } from './activity-log-filter-schema';

type ActivityLogFilter = {
  activities?: string[] | null;
  search?: string | null;
};

const activityDropdownOptions = [
  {
    label: 'All',
    value: 'All',
    choices: eventPurposeOptions,
  },
];

export type ActivityLogFilterProps = {
  onAddActivity: () => void;
  onFilterChange: (values: ActivityLogFilter) => void;
  showFilters: boolean;
};

export const ActivityLogFilter = ({
  onAddActivity,
  onFilterChange,
  showFilters,
}: ActivityLogFilterProps) => {
  const isDetailPage = (): boolean => {
    return (
      window.location.href.includes('talent-detail') ||
      window.location.href.includes('opportunity-detail')
    );
  };

  return (
    <Form
      initialValues={{}}
      name="activityLogFilter"
      onSubmit={changedData => {
        onFilterChange(changedData);
      }}
      submitOnChange
      schema={activityLogFilterSchema}
    >
      {() => (
        <Gutter top="16px">
          <Layout direction="vertical">
            <Grid>
              <GridRow>
                <GridColumn name="SEARCH_COLUMN" width={isDetailPage() ? 4 : 6}>
                  {!!showFilters && (
                    <Input name="search" placeholder="Search" icon="search" />
                  )}
                </GridColumn>
                <GridColumn name="BUTTON_COLUMN" width={isDetailPage() ? 8 : 6}>
                  <Layout position="right">
                    <Button
                      name="add_activity_button"
                      pattern="secondary"
                      onClick={() => {
                        onAddActivity();
                      }}
                    >
                      Add Activity
                    </Button>
                  </Layout>
                </GridColumn>
              </GridRow>
            </Grid>
            {!!showFilters && (
              <Gutter top="16px">
                <DropdownTree
                  displayKey="label"
                  label="Filter by Activity"
                  name="activities"
                  placeholder="Select an activity"
                  options={activityDropdownOptions}
                  valueKey="value"
                  nestedKey="choices"
                  direction="down"
                />
              </Gutter>
            )}
          </Layout>
        </Gutter>
      )}
    </Form>
  );
};
